/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRestaurantsResult } from '../../models/get-restaurants-result';

export interface GetRestaurants$Params {
  SiteName: string;
}

export function getRestaurants(
  http: HttpClient,
  rootUrl: string,
  params: GetRestaurants$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetRestaurantsResult>> {
  const rb = new RequestBuilder(rootUrl, getRestaurants.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRestaurantsResult>;
    }),
  );
}

getRestaurants.PATH = '/Restaurants';
